import { getLoggedInUser } from '../helpers/authUtils';

const configDomain = process.env.REACT_APP_CONFIG_DOMAIN || 'aheadallplus.blueseas.co.th'; // 'aheadallplus.winservecorp.co.th';
const configWebUrl = process.env.REACT_APP_CONFIG_WEB_URL || `https://${configDomain}`;
const configApiUrl = process.env.REACT_APP_CONFIG_API_URL || `https://${configDomain}:3000`;

const configOptions = (method, body) => {
    var token = '';
    var user = getLoggedInUser();
    if (user && user.token) {
        token = 'Bearer ' + getLoggedInUser().token;
    }

    if (method === 'GET') {
        return { method: method, headers: { ContentType: 'application/json', Authorization: token } };
    }
    // return { method: method, body: JSON.stringify(body ? body : {}), headers: { ContentType: 'application/json' } };
    // headers: new Headers({'content-type': 'application/json'})

    return {
        method: method,
        body: JSON.stringify(body ? body : {}),
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded' // depend on body-parser
            'Content-Type': 'application/json', //normal work
            Authorization: token,
            // Accept: 'application/json'
        },
    };
};

//=================== CALL API =============================//
const configCallApi = (url, options) => {
    try {
        // console.log('call url: ' + url);
        // console.log(options);
        // if (options && options.method !== 'GET') {
        //     console.log('call options body: ' + options.body);
        // }

        return fetch(url, options)
            .then((response) => response.text()) //response.json()
            .then((datas) => {
                // console.log('This is your data', datas)
                // saveLogs(url, options, datas);

                // console.log('datas: ', datas);

                if (datas) {
                    let json = JSON.parse(datas);
                    // console.log('json: ', JSON.stringify(json));

                    if (json.error === undefined || json.error === null) {
                        return {
                            status: true,
                            message: 'success',
                            response: json,
                        };
                    } else {
                        return {
                            status: false,
                            message: json.message,
                            response: null,
                        };
                    }
                } else {
                    return {
                        status: true,
                        message: 'success',
                        response: null,
                    };
                }
            });
    } catch (error) {
        let message;
        switch (error.status) {
            case 500:
                message = 'Internal Server Error';
                break;
            case 401:
                message = 'Invalid credentials';
                break;
            default:
                message = error;
        }
        return {
            status: false,
            message: message,
            response: null,
        };
    }
};

export const apiUrl = configApiUrl;

export default {
    configDomain,
    configWebUrl,
    configApiUrl,
    configOptions,
    configCallApi,
};
